import { useState } from "react";
import { Mail, Check } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export default function NewsletterSignup() {
    const [email, setEmail] = useState("");
    const [consent, setConsent] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState(null);

    const submit = async (e) => {
        e.preventDefault();
        setError(null);
        if (!consent) {
            setError("Acceptez la politique de confidentialité.");
            return;
        }
        setSubmitting(true);
        try {
            await api.post("/newsletter", { email, consent });
            setDone(true);
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setSubmitting(false);
        }
    };

    if (done) {
        return (
            <div className="flex items-start gap-3 text-sm text-brand-bg/85" data-testid="newsletter-success">
                <Check size={16} className="text-brand-sage mt-1 shrink-0" />
                <p>Merci, votre adresse est enregistrée. Vous recevrez nos prochaines actualités.</p>
            </div>
        );
    }

    return (
        <form onSubmit={submit} className="space-y-3" data-testid="newsletter-form" noValidate>
            <div className="flex gap-2">
                <div className="flex items-center gap-2 flex-1 px-3 py-2.5 bg-brand-bg/10 border border-brand-bg/30 focus-within:border-brand-sage">
                    <Mail size={14} className="text-brand-sage shrink-0" />
                    <input
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="votre@email.fr"
                        className="bg-transparent flex-1 outline-none text-sm placeholder-brand-bg/40"
                        data-testid="newsletter-email"
                        autoComplete="email"
                    />
                </div>
                <button
                    type="submit"
                    disabled={submitting}
                    data-testid="newsletter-submit"
                    className="px-5 text-xs uppercase tracking-[0.18em] bg-brand-sage hover:bg-brand-sageDark text-brand-bg disabled:opacity-50"
                >
                    {submitting ? "…" : "S'inscrire"}
                </button>
            </div>
            <label className="flex items-start gap-2 text-xs text-brand-bg/60 cursor-pointer">
                <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 accent-brand-sage" />
                <span>J'accepte de recevoir les actualités de Japet Agencement.</span>
            </label>
            {error && <p className="text-xs text-red-300">{error}</p>}
        </form>
    );
}
